import { AgencyService } from './../common-theme/api/agency.service';
import { Component, OnInit, Injector, Inject } from '@angular/core';
import { HousesBaseComponent } from './../common-theme/index';
import { Project } from './../common-theme/models/index';
import { ActivatedRoute } from '@angular/router';
import { DOCUMENT } from '@angular/platform-browser';

@Component({
  selector: 'app-houses',
  templateUrl: './houses.component.html',
  styleUrls: ['./houses.component.scss']
})

export class HousesComponent extends HousesBaseComponent implements OnInit {
  pageHeight: number;
  projects: Project[];
  sortItems: any[] = [
    {
      id: 'room_count',
      text: 'nr. camere'
    },
    {
      id: 'bathroom_count',
      text: 'nr. băi'
    },
    {
      id: 'size',
      text: 'suprafață'
    },
    {
      id: 'price',
      text: 'preț'
    }
  ];

  constructor(
    injector: Injector,
    agencyService: AgencyService,
    route: ActivatedRoute,
    @Inject('WINDOW') public window: any,
    @Inject(DOCUMENT) public document: any,
    @Inject('SCREEN') public screen: any
  ) {
    super(injector, agencyService, route, window, document);
  }

  ngOnInit(): void {
    super.ngOnInit();

    if (this.screen) {
      this.pageHeight = this.screen.height - 500;
    }

    this.resetSliderSearch();

    this.route.data.forEach((data: any) => {
      if (data.projects)
        this.projects = data.projects;

      this.projects = this.projects.filter(project =>
        project.id !== 39 && project.id !== 40
      );
    });

    if (this.window) {
      this.window.addEventListener('scroll', this.onScroll());
    }

    this.filterSoldProjects();
  }

  resetSliderSearch(): void {
    this.getPropertySearch().min_size_sqm = this.advancedLimits.min_size_sqm;
    this.getPropertySearch().max_size_sqm = 98;
    this.getPropertySearch().min_buy_price_eur = this.advancedLimits.min_buy_price_eur;
    this.getPropertySearch().max_buy_price_eur = this.advancedLimits.max_buy_price_eur;
  }

  filterSoldProjects(): void {
    this.projects = this.projects.filter(
      project => {
        if (project.sale_status !== 'sold_out')
          return project;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/houses/houses.component.ts